import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IMessagingSender } from 'src/app/models/IMessaging';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-transfor-users',
  templateUrl: './transfor-users.component.html',
  styleUrls: ['./transfor-users.component.css']
})
export class TransforUsersComponent implements OnInit {
  TransForUsersForm: FormGroup;
  public roles: IUserDetails[];
  public rxReqDetails: IMessagingSender;
  constructor(private formBuilder: FormBuilder
    , private sharedService: SharedService
    , private activeserviceService: ActiveserviceService
    , private toastr: ToastrService
    , public dialogRef: MatDialogRef<TransforUsersComponent>
    , @Inject(MAT_DIALOG_DATA) public data: IMessagingSender) {
    this.rxReqDetails = this.data;
  }

  ngOnInit() {
    this.TransForUsersForm = this.formBuilder.group({
      transforUser: [''],
    });
    this.getAllRoles();
  }

  getAllRoles() {
    this.activeserviceService.getAllUsers().subscribe(result => {
      this.roles = result;
      this.usersfilter();
    },
      (err: any) => console.log(err)
    );
    // this.sharedService.getUsersbyMultipleRoles("Doctor", "Nurse", null, null).subscribe(result => {
    //   this.roles = result;
    // });
  }

  onSubmit() {
    if(this.userobj != null){
      this.dialogRef.close(this.userobj);
    }else{
      this.toastr.warning("Please Select One TransforUser");
      return;
    }
    
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  rolesOptions: Observable<IUserDetails[]>;
  usersfilter() {
    this.rolesOptions = this.TransForUsersForm.get('transforUser')!.valueChanges.pipe(
      startWith(""),
      map(value => this._ivsite(value))
    );
  }
  private _ivsite(value: string): IUserDetails[] {
    const filterValue = value.toString().toLowerCase();
    if (this.roles != undefined) {
      return this.roles.filter(option => option.userName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  displayFn(user: IUserDetails): string {
    return user && user.userName ? user.userName : '';
  }

  userobj: IUserDetails = null;
  onSelectionChanged(event: IUserDetails) {
    let userlist = this.roles.filter(x => x.userId === event.userId);
    if (userlist.length > 0) {
      this.userobj = event;
    } else {
      this.userobj = null;
    }
  }
}
